import apiClient from './apiService';

export default {

  isAuthenticated() {
    const user = localStorage.getItem('user');
    return user && user !== '{}' && user !== 'null';
  },

  login(credentials) {
    return apiClient.post('/login', credentials);
  },


  logout() {
    return apiClient.post('/logout');
  },


  async getUser() {
      const response = await apiClient.get('/user');
      return response.data;

  },

};
